export const balanceTableColumns = [
  {
    Header: "Departamento",
    accessor: "name",
  },
  {
    Header: "Account Type",
    accessor: "accountType",
  },
  {
    Header: "Account Name",
    accessor: "accountName",
  },
  {
    Header: "Account Number",
    accessor: "accountNumber",
  },
  {
    Header: "Account Currency",
    accessor: "accountCurrency",
  },
  {
    Header: "Account Balance",
    accessor: "balance",
  }
];
